exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Image {\n  background: #eee; }\n  .Image__Image {\n    opacity: 0;\n    width: 100%;\n    height: auto;\n    display: block; }\n    .Image__Image--Loaded {\n      opacity: 1;\n      transition: opacity 0.1s; }\n    .Image__Image--Complete {\n      opacity: 1;\n      transition: none; }\n", ""]);

// exports
